/* eslint global-require: "off" */
export default [
  {
    name: "Casa di Mezzo",
    beds: 2,
    bath: 2,
    person: 6,
    pool: "Shared",
    preferred: { img: require("./assets/__9364.jpg"), caption: "" },
    imagelist: [
      { img: require("./assets/__9248.jpg"), caption: "" },
      { img: require("./assets/__9291.jpg"), caption: "" },
      { img: require("./assets/__9360.jpg"), caption: "" },
      { img: require("./assets/__9364.jpg"), caption: "" },
      { img: require("./assets/__9409.jpg"), caption: "" },
      { img: require("./assets/__9402.jpg"), caption: "" },
      { img: require("./assets/__9369.jpg"), caption: "" }
    ]
  },
  {
    name: "Villa Montisi",
    beds: 3,
    bath: 3,
    person: 8,
    pool: "Private",
    preferred: { img: require("./assets/__9998.jpg"), caption: "" },
    imagelist: [
      { img: require("./assets/__8893.jpg"), caption: "" },
      { img: require("./assets/__8934.jpg"), caption: "" },
      { img: require("./assets/__9049.jpg"), caption: "" },
      { img: require("./assets/__8955.jpg"), caption: "" },
      { img: require("./assets/__8970.jpg"), caption: "" },
      { img: require("./assets/__9001.jpg"), caption: "" },
      { img: require("./assets/__9016.jpg"), caption: "" },
      { img: require("./assets/__9059.jpg"), caption: "" },
      { img: require("./assets/__8975.jpg"), caption: "" },
      { img: require("./assets/__9998.jpg"), caption: "" }
    ]
  },
  {
    name: "Casa Beppe",
    beds: 2,
    bath: 1,
    person: 6,
    pool: "Shared",
    preferred: { img: require("./assets/__9235.jpg"), caption: "" },
    imagelist: [
      { img: require("./assets/__9095.jpg"), caption: "" },
      { img: require("./assets/__9089.jpg"), caption: "" },
      { img: require("./assets/__9137.jpg"), caption: "" },
      { img: require("./assets/__9150.jpg"), caption: "" },
      { img: require("./assets/__9158.jpg"), caption: "" },
      { img: require("./assets/__9165.jpg"), caption: "" },
      { img: require("./assets/__9230.jpg"), caption: "" },
      { img: require("./assets/__9235.jpg"), caption: "" }
    ]
  },
  {
    name: "Casa Gisella",
    beds: 2,
    bath: 1,
    person: 6,
    pool: "Shared",
    preferred: { img: require("./assets/__1600.jpg"), caption: "" },
    imagelist: [
      { img: require("./assets/__1600.jpg"), caption: "" },
      { img: require("./assets/__8360.jpg"), caption: "" },
      { img: require("./assets/__8304.jpg"), caption: "" },
      { img: require("./assets/__8354.jpg"), caption: "" },
      { img: require("./assets/__8366.jpg"), caption: "" },
      { img: require("./assets/__8383.jpg"), caption: "" },
      { img: require("./assets/__8397.jpg"), caption: "" },
      { img: require("./assets/__9469.jpg"), caption: "" }
    ]
  },
  {
    name: "Villa Santa Caterina",
    beds: 2,
    bath: 2,
    person: 6,
    pool: "Shared",
    preferred: { img: require("./assets/__7901.jpg"), caption: "" },
    imagelist: [
      { img: require("./assets/__7711.jpg"), caption: "" },
      { img: require("./assets/__7770.jpg"), caption: "" },
      { img: require("./assets/__7785.jpg"), caption: "" },
      { img: require("./assets/__7806.jpg"), caption: "" },
      { img: require("./assets/__7871.jpg"), caption: "" },
      { img: require("./assets/__7901.jpg"), caption: "" },
      { img: require("./assets/__7913.jpg"), caption: "" },
      { img: require("./assets/__7888.jpg"), caption: "" },
      { img: require("./assets/__1623.jpg"), caption: "" }
    ]
  },
  {
    name: "Villa Ampella",
    beds: 2,
    bath: 2,
    person: 6,
    pool: "Shared",
    preferred: { img: require("./assets/__1576.jpg"), caption: "" },
    imagelist: [
      { img: require("./assets/__1576.jpg"), caption: "" },
      { img: require("./assets/__1585.jpg"), caption: "" },
      { img: require("./assets/__1231.jpg"), caption: "" },
      { img: require("./assets/__1189.jpg"), caption: "" },
      { img: require("./assets/__1304.jpg"), caption: "" },
      { img: require("./assets/__1264.jpg"), caption: "" },
      { img: require("./assets/__1291.jpg"), caption: "" },
      { img: require("./assets/__9420.jpg"), caption: "" }
    ]
  }
];



// WEBPACK FOOTER //
// ./src/villa-data.js